import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [이벤트>이벤트현황/이력] Smart Analyzer 과거분석 최근 30일 이벤트 이력 정보 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getEventHistListByHashkeyIdLast30Days(params) {
    return axios.post(`${baseUrl}/event/event-hist/get-event-hist-list-by-hashkey-id-last-30-days.do`, params);
  },
  /**
   * [이벤트>이벤트현황/이력] Smart Analyzer 과거분석 최근 30일 이벤트 이력 목록 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getEventHistListByHashkeyIdLast30DaysList(params) {
    return axios.post(`${baseUrl}/event/event-hist/get-event-hist-list-by-hashkey-id-last-30-days-list.do`, params);
  },

  /**
   * [이벤트>이벤트현황/이력] Smart Analyzer 미래예측 정보 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getForecastEvent(params) {
    return axios.get(`${baseUrl}/smart/get-forecast-event.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/event-common.js